<template>
    <b-badge v-if="$safe(row,'Locked')" variant="secondary">Kilitli</b-badge>
    <b-badge v-else variant="dark">İşlem Yapılabilir</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'

export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    },
}
</script>

<style>

</style>